<template>
  <modal
    :show.sync="isActiveLeave"
    size="lg"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
    @close="closeModal"
  >
    <div class="flex justify-between">
      <h2 class="fsize25 font-semibold sm-fsize18 text-center">
        Doctor Details
      </h2>
      <img
        src="@/assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLeave = false"
      />
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <div class="mt-4">
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
          class="rounded-full widtht20percent m-auto display-none custmodal"
        />
        <img
          v-if="image"
          :src="image"
          ref="cover"
          class="rounded-full widtht20percent m-auto display-none custmodal"
        />
        <div class="text-center text-red" v-if="image" @click="handleRemove">
          Remove image
        </div>
        <span v-if="imageErr" class="flex justify-center small text-danger">{{
          msg.image
        }}</span>
        <p class="text-center">Upload your picture (optional)</p>
      </div>
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="py-4 customboxed">
          <p class="mb-1">Name<span class="text-red"> *</span></p>
          <base-input
            class=""
            name="name"
            :rules="{ required: true }"
            placeholder="Enter your name"
            v-model="name"
            @blur="handleName()"
          >
          </base-input>
          <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
        </div>
        <div class="customboxed">
          <p class="mb-1">Degree</p>
          <base-input
            class="mb-3"
            name="degree"
            placeholder="Enter your degree"
            v-model="degree"
          >
          </base-input>
        </div>
        <div class="customboxed">
          <p class="mb-1">Description</p>
          <base-input
            class="mb-3"
            name="description"
            placeholder="Enter your description"
            v-model="description"
          >
          </base-input>
        </div>

        <base-button
          type="primary"
          class="w-full my-2 fsize18"
          native-type="submit"
          >Submit</base-button
        >
      </b-form>
    </validation-observer>
    <!-- <div v-html="selectedTesimonial.html"></div> -->
    <template slot="footer"> <div></div> </template>
  </modal>
</template>

<script>
import FileUploader from "@/components/FileUploader";
// import { mapState } from "vuex";

export default {
  data() {
    return {
      name: "",
      degree: "",
      description: "",
      image: null,
      coverImage: null,
      nameErr: false,
      linkErr: false,
      imageErr: false,
      msg: {
        name: "",
        image: "",
      },
    };
  },
  components: {
    FileUploader,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedTesimonial: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLeave: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },

    // ...mapState("testimonial", {
    //   testimonial: "testimonial",
    // }),
  },

  methods: {
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    // async getDoctor() {
    //   let loader;
    //   try {
    //     let payload = {
    //       limit: 5,
    //       offset: 0,
    //     };
    //     loader = this.$loading();
    //     const getDoctor = await this.$store.dispatch(
    //       "cmsDoctor/getDoctor",
    //       payload
    //     );
    //     loader.close();
    //     // console.log(getDoctor);
    //   } catch (error) {
    //     console.log(error);
    //     loader.close();
    //   }
    // },
    async onSubmit() {
      this.name = this.name.trim();
      this.degree = this.degree.trim();
      this.description = this.description.trim();

      const payload = new FormData();
      payload.append("name", this.name);

      if (this.degree) payload.append("degree", this.degree);
      if (this.description) payload.append("description", this.description);
      if (this.coverImage) payload.append("image", this.coverImage);

      let loader;

      try {
        // console.log(payload);
        loader = this.$loading();
        const createDoctor = await this.$store.dispatch(
          "doctor/createDoctor",
          payload
        );

        if (createDoctor.code === 200) {
          // console.log(createDoctor);
          loader.close();
          this.closeModal();
          await this.$swal({
            text: "Doctor successfully added!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.name = "";
          this.degree = "";
          this.description = "";
          this.coverImage = null;
          this.image = null;
          // this.getDoctor();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    handleName() {
      this.nameErr = false;
      if (!/^[a-zA-Z ]+$/.test(this.name)) {
        this.nameErr = true;
        this.msg.name = "Name should not be numeric value";
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style>
.custinputborder {
  border: 1px solid #808080;
  border-radius: 4px;
}
.widtht20percent {
  width: 24%;
  height: 140px !important;
}
.modal-lg {
  width: 650px;
}
@media (max-width: 640px) {
  .modal-lg {
    width: 330px;
  }
  .widtht20percent {
    width: 50%;
    height: 140px !important;
  }
}
</style>
